export const giveTipUrl = '/transactions/createtransactions';
export const getTransactionsUrl = '/transactions';
export const getBalanceUrl = '/payee/getBalance';
